import { FORCE_LOGOUT_ACTIONS } from '../../UForceLogout/constant';

// Initial state for the force-logout slice
export const initialForceLogoutState = {
    data: null,
};

// Idempotency lives here — first SET wins; subsequent SETs are ignored
// so duplicate broadcasts during sign-out-all do not stack popups.
export const forceLogoutReducer = (state, action) => {
    switch (action.type) {
        case FORCE_LOGOUT_ACTIONS.SET: {
            if (state && state.data) return state;
            return { data: action.payload };
        }
        case FORCE_LOGOUT_ACTIONS.CLEAR:
            return initialForceLogoutState;
        default:
            return state;
    }
};
